// extracted by mini-css-extract-plugin
export default {"tab":"tabs_tab__ltQE6","active":"tabs_active__MLHNx","tabcontent":"tabs_tabcontent__5LKuD"};